export default "__VITE_ASSET__YOUu2bil__"